import { pgEnum, pgTable, text, unique, uuid } from "drizzle-orm/pg-core";
import { catalogItems } from "./catalog-item";

export const externalIdSystemEnum = pgEnum("external_id_system", [
  "ROCA",
  "TCGPLAYER",
  "STOCKX",
  "FANATICS",
  "OTHER",
]);

/**
 * A vendor system's own id for one catalog item. Supporting vendor listings later means
 * an additional nullable vendor_listing_id plus a check constraint, not built now.
 */
export const externalProductIds = pgTable(
  "external_product_ids",
  {
    catalogItemId: uuid("catalog_item_id")
      .notNull()
      .references(() => catalogItems.id),
    system: externalIdSystemEnum("system").notNull(),
    value: text("value").notNull(),
  },
  (t) => [unique().on(t.system, t.value)],
);
